import { Reference } from '@approvalmax/types';
import { DropdownEditor } from '@approvalmax/ui';
import { PlainDataProvider } from 'modules/data-providers';
import { changeStandaloneFieldValue } from 'pages/requestForm/actions';
import { FC, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { messages } from './StandaloneField.messages';
import { StandaloneFieldProps } from './StandaloneField.types';

const StandaloneField: FC<StandaloneFieldProps> = memo((props) => {
    const { fieldValue, showValidationErrors } = props;

    const dispatch = useDispatch();

    const handleChangeStandaloneFieldValue = useCallback(
        (newValue: Reference | null) => {
            dispatch(changeStandaloneFieldValue(fieldValue.field.id, newValue));
        },
        [dispatch, fieldValue.field.id]
    );

    return (
        <PlainDataProvider items={fieldValue.field.exactValues}>
            <DropdownEditor
                qa={fieldValue.field.name}
                invalid={showValidationErrors && !fieldValue.value}
                value={fieldValue.value}
                onChange={handleChangeStandaloneFieldValue}
                placeholder={messages.standaloneFieldPlaceholder}
            />
        </PlainDataProvider>
    );
});

export default StandaloneField;
